const getUserId = () => {
  return JSON.parse(localStorage.getItem('msal.custom')).userId;
};

const getUserCountry = () => {
  return {
    UNIDADE_PAIS: JSON.parse(localStorage.getItem('msal.custom')).country,
  };
};

const getCustomerId = () => {
  
  return localStorage.getItem('customerId');
}

const getAud = () => {
  return JSON.parse(localStorage.getItem('msal.custom')).aud;
}

const getToken = () => {
    let token = localStorage.getItem('msal.' + getAud() + '.idtoken');
    return token;
}

export { getUserId, getUserCountry, getCustomerId, getToken };
